"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadDataWarning = DownloadDataWarning;
exports.ExportDataWarning = ExportDataWarning;
exports.RetrofitSyncSuccess = exports.RecoveryEmail = exports.Pending = exports.OptedOutEdison = exports.OptedInEdison = void 0;
exports.WarningInfoContainer = WarningInfoContainer;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _Container = _interopRequireDefault(require("./components/Container"));
var _excluded = ["description", "containerCls", "textAlign"],
  _excluded2 = ["email", "isSending", "onResend"],
  _excluded3 = ["isLoading", "accounts", "onClose"];
var InfoBanner = function InfoBanner(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    className = _ref.className,
    containerCls = _ref.containerCls,
    childrenCls = _ref.childrenCls,
    textAlign = _ref.textAlign,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent;
  var textDiretion = textAlign || 'text-center';
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    className: containerCls,
    variant: "info",
    transparent: transparent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-1 font-bold text-sm', childrenCls, textDiretion)
  }, children), !(0, _isNil["default"])(onClose) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 w-12 cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], null)));
};
var Pending = exports.Pending = function Pending(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(InfoBanner, props, t('premium.setup.infoBanner'));
};
function WarningInfoContainer(props) {
  var description = props.description,
    containerCls = props.containerCls,
    textAlign = props.textAlign,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(InfoBanner, (0, _extends2["default"])({
    textAlign: textAlign,
    containerCls: (0, _classnames["default"])('!h-12 rounded-xl', containerCls)
  }, rest), /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    className: "primary mr-4",
    style: {
      fontSize: '1.5rem'
    }
  }), description);
}
var OptedInEdison = exports.OptedInEdison = function OptedInEdison(props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement(WarningInfoContainer, {
    textAlign: "text-left",
    containerCls: "mt-4 mb-12 !px-2 !h-12 rounded-xl",
    description: t('settings.securityPrivacy.optIn.banner.description')
  });
};
var OptedOutEdison = exports.OptedOutEdison = function OptedOutEdison(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(WarningInfoContainer, {
    textAlign: "text-left",
    containerCls: "mt-4 mb-12 !px-2 !h-12 rounded-xl",
    description: t('settings.securityPrivacy.optOut.banner.description')
  });
};
var RecoveryEmail = exports.RecoveryEmail = function RecoveryEmail(_ref2) {
  var email = _ref2.email,
    isSending = _ref2.isSending,
    onResend = _ref2.onResend,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(InfoBanner, props, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "auth.recoveryEmailUnverified",
    values: {
      email: email
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('font-bold underline select-none', {
      'text-gray-light cursor-default': isSending,
      'cursor-pointer': !isSending
    }),
    onClick: !isSending ? onResend : undefined
  })));
};
var RetrofitSyncSuccess = exports.RetrofitSyncSuccess = function RetrofitSyncSuccess(_ref3) {
  var isLoading = _ref3.isLoading,
    accounts = _ref3.accounts,
    onClose = _ref3.onClose,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  if (accounts.length === 0) {
    return null;
  }
  var email = accounts.length === 1 ? accounts[0] : undefined;
  return /*#__PURE__*/_react["default"].createElement(InfoBanner, (0, _extends2["default"])({}, props, {
    onClose: !isLoading ? onClose : undefined,
    className: (0, _classnames["default"])({
      'opacity-50': isLoading
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "retrofit.syncProgress.banner.success",
    values: {
      email: email
    },
    count: accounts.length
  }));
};
function ExportDataWarning() {
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement(WarningInfoContainer, {
    containerCls: "!px-4",
    description: t('dataExport.beforeRequest.warning.description')
  });
}
function DownloadDataWarning() {
  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation5.t;
  return /*#__PURE__*/_react["default"].createElement(WarningInfoContainer, {
    containerCls: "!px-4",
    description: t('dataExport.downloadSuccess.warning')
  });
}
var _default = exports["default"] = InfoBanner;
//# sourceMappingURL=Info.js.map